import PropTypes from 'prop-types';
import React from 'react';
import { Route, Switch } from 'react-router-dom';
import FormsList from './list';
import FormsDetail from './details';
import PageError from '../error/pageError';

export default function FormRouter({ organization, event, path }) {
    return (
        <Switch>
            <Route exact path={`${path}`} render={() => <FormsList organization={organization} event={event} />} />
            <Route
                exact
                path={`${path}/:formId([0-9]+)`}
                render={basenameProps => {
                    const formId = parseInt(basenameProps.match.params.formId);
                    return <FormsDetail organization={organization} event={event} formId={formId} />;
                }}
            />
            <Route
                exact
                path={`${path}/new`}
                render={basenameProps => {
                    return <FormsDetail organization={organization} event={event} />;
                }}
            />
            <Route render={() => <PageError errorCode={404} backHomeUrl={`/ticket/O${organization.id}/E${event.id}/dashboard`} />} />
        </Switch>
    );
}

FormRouter.propTypes = {
    organization: PropTypes.object.isRequired,
    event: PropTypes.object.isRequired,
    path: PropTypes.string.isRequired
};
